import React, { useContext } from "react";
import MunicipioContext from "../../context/MunicipiosContext";
import { Link } from "react-router-dom";

import Page from "../templates/page";

const Home = () => {
  //Onbtengo el listado de municipio a través del contexto.
  const { municipios } = useContext(MunicipioContext);

  if (municipios.lengt === 0) return null;
  return (
    <Page>
      <img
        className="home-logo"
        src="/img/logos/logo_nombre_ppr.svg"
        alt="Presupuesto Participativo Raíz"
      />
      <div className="home-text">
        <p>
          Plataforma de Presupuesto Participativo desarrollada por el Programa
          Raíz de la Secretaría de Extensión de la Universidad Nacional de
          Córdoba.
        </p>
        <p>Municipios Participantes:</p>
        <div className="centrado">
          <div className="btn-group-vertical">
            {municipios.map((municipio) => (
              <Link
                to={`/municipio/${municipio.nombreUrl}`}
                key={municipio._id}
                className="btn btn-lg ppr-btn-celeste m-2"
              >
                {municipio.nombre}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </Page>
  );
};

export default Home;
